import {
  ALL_STAKEHOLDER_TYPES_ORDER,
  normalizeStakeholderCode,
  RESPONDER_STAKEHOLDER_TYPES,
} from "./stakeholder";
import { parseRegistrationOperatorUser } from "./stakeholderSwitcherAccess";

/** Default Buxus tenant (`portal`). Operator tenants (e.g. oneok) are any other tenant. */
export const BUXUS_PORTAL_TENANT_ID = "6F2DC493-F969-EBF2-C336-3A12515B7BDD";
export const BUXUS_PORTAL_TENANT_NAME = "portal";

export function isPortalTenant(params: {
  tenantId?: string | null;
  tenantName?: string | null;
}): boolean {
  const id = params.tenantId?.trim();
  if (id) return id.toLowerCase() === BUXUS_PORTAL_TENANT_ID.toLowerCase();
  const name = params.tenantName?.trim();
  return !!name && name.toLowerCase() === BUXUS_PORTAL_TENANT_NAME;
}

/** Signed in to a non-portal tenant (oneok, etc.). Host / no tenant is not an operator tenant. */
export function isOperatorTenant(params: {
  tenantId?: string | null;
  tenantName?: string | null;
}): boolean {
  const id = params.tenantId?.trim();
  const name = params.tenantName?.trim();
  if (!id && !name) return false;
  return !isPortalTenant(params);
}

/**
 * Operator-company account: non-portal tenant, or CRM `Operator_User` on the registration profile.
 */
export function isOperatorAccount(params: {
  tenantId?: string | null;
  tenantName?: string | null;
  registrationProfileData?: unknown | null;
}): boolean {
  return (
    isOperatorTenant(params) || parseRegistrationOperatorUser(params.registrationProfileData)
  );
}

/** ET / EC / ER (including legacy aliases via {@link normalizeStakeholderCode}). */
export function isStudioEntryStakeholder(raw: string | null | undefined): boolean {
  const canon =
    normalizeStakeholderCode(raw, RESPONDER_STAKEHOLDER_TYPES) ??
    normalizeStakeholderCode(raw, ALL_STAKEHOLDER_TYPES_ORDER);
  if (canon) return (RESPONDER_STAKEHOLDER_TYPES as readonly string[]).includes(canon);
  const prefix = raw?.trim().slice(0, 2).toUpperCase();
  return prefix === "ET" || prefix === "EC" || prefix === "ER";
}

/**
 * Training Portal button only. Direct `/scenarios` is not gated by this.
 * Operator (tenant or Operator_User) or responder type ET / EC / ER.
 */
export function canShowScenarioStudioTrainingButton(params: {
  tenantId?: string | null;
  tenantName?: string | null;
  registrationProfileData?: unknown | null;
  stakeholderType?: string | null;
}): boolean {
  return isOperatorAccount(params) || isStudioEntryStakeholder(params.stakeholderType);
}
